import React, {useEffect, useRef, useState} from 'react'
import {errorClear, errorShow} from '../../Utility/Form'
import PropTypes, {shape} from 'prop-types'

/**
 * Primary UI component for user interaction
 */
export const FormRadios = ({fieldText, label, name, required, options, validationHash, value, ...props }) => {
  const [inputIsInvalid, inputIsInvalidSet] = useState(false)
  const [hasInitialised, hasInitialisedSet] = useState(false)
  const inputError = useRef(null)

  /**
   * The error ID.
   *
   * @type {string}
   */
  const errorId = `${name}_error`

  /**
   * The error message class
   *
   * @type {string}
   */
  const errorSpan = 'b-form-input__error-message'

  /**
   * Handle any form changes.
   *
   * @param {Event} event
   *   The triggered change event
   */
  const handlerInputChange = event => {
    props.onInputChange(name, event.target.value)
  }

  /**
   * Validate the element.
   */
  const validate = () => {
    if ((required && value) || !required) {
      inputIsInvalidSet(false)
      if (inputError.current) {

      }
    }
    else {
      inputIsInvalidSet(true)
      if (inputError.current) {

      }
    }
  }

  useEffect(() => {
    hasInitialisedSet(true)
  }, [])

  useEffect(() => {
    if (hasInitialised) {
      validate()
    }
  }, [value, validationHash])

  return(
    <fieldset className={'b-form-fieldset'} aria-invalid={inputIsInvalid} data-state={inputIsInvalid ? 'error' : 'ok'}>
      <legend>{label}</legend>
      {fieldText && <div className={'b-form-fieldset__field-text'}>{fieldText}</div>}

      <div className={'b-form-fieldset__inner'}>
        {options.map((option, key) => {
          return(
            <div key={key} className="b-form-input" data-type={'radio'} data-state={inputIsInvalid ? 'error' : 'ok'}>
              <input
                id={`${name}_${key}`}
                name={name}
                type={'radio'}
                aria-describedby={errorId}
                aria-required={required}
                value={option.value}
                onChange={handlerInputChange}
                checked={option.value === value} />
              <label htmlFor={`${name}_${key}`}>{option.label}</label>
            </div>
          )
        })}

        {required && inputIsInvalid ?
          <div className="b-form-input__error-wrapper">
            <span ref={inputError} className={errorSpan} id={errorId} aria-live="assertive" >
              Please select an option
            </span>
          </div> : null}
      </div>
    </fieldset>


  )
}

FormRadios.propTypes = {
  label         : PropTypes.string.isRequired,
  name          : PropTypes.string.isRequired,
  fieldText     : PropTypes.string,
  required      : PropTypes.bool.isRequired,
  onInputChange : PropTypes.func.isRequired,
  options       : PropTypes.array.isRequired,
  value         : PropTypes.string,
  validationHash: PropTypes.string,
}

FormRadios.defaultProps = {
  required: false
}
